<template>
<div class="manager_dashboard">
  <user-menu />
  <div class="wrapper">
    <div class="content-wrapper">
      <div class="container-wrapper center">
      <div style="text-align: center;">
          <flash-message autoHide variant="success"></flash-message>
      </div>
        <div v-if="action == 'view-profile'">
        <div class="content-main-wrapper add_account_form center">
          <div class="db-card">
            <div class="row justify-content-lg-center justify-content-xl-center">
                <div class="col-11">
                    <div class="row">
                        <div class="col-6 col-sm-9 col-md-9 col-lg-10 col-xl-9">
                            <div class="title">{{ pageName }}</div>
                        </div>
                        <div class="col-6 col-sm-3 col-md-3 col-lg-2 col-xl-3 text-right">
                            <a @click="openEditProfileForm()" class="btn btn-primary btn-sm dbEditBtn">Edit</a>
                        </div>
                    </div>
                    <hr class="view-mentee-hr"/>
                    <div class="row mentor_row">
                        <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                            <div class="d-flex justify-content-center">
                                <div class="fa fa-user-circle-o user-icon"></div>
                            </div>
                        </div>
                        <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                            <div class="d-flex justify-content-center">
                                <div class="db-mentor-name">Role: 
                                  <span class="roles" v-for="(option, key, index) in roles" :key="index">
                                    <span v-if="roles.length == (key+1)">{{ rolesFormatter(option) }}</span>
                                    <span v-else>{{ rolesFormatter(option) }}, </span>
                                  </span>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="personal-details-wrapper">
                    <div class="row grid_row">
                      <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                        <div class="title">Personal Details</div>
                      </div>
                    </div>
                    <div class="row grid_row">
                        <div class="col-6 col-sm-6 col-md-6 col-lg-6 col-xl-6">
                            <div class="label_txt">First Name: </div>
                        </div>
                        <div class="col-6 col-sm-6 col-md-6 col-lg-6 col-xl-6 text-right">
                            <div class="label_txt">Last Name: </div>
                        </div>
                        <div class="col-6 col-sm-6 col-md-6 col-lg-6 col-xl-6">
                            <div class="label_val">{{ first_name }}</div>
                        </div>
                        <div class="col-6 col-sm-6 col-md-6 col-lg-6 col-xl-6 text-right">
                            <div class="label_val">{{ last_name }}&nbsp;&nbsp;</div>
                        </div>
                    </div>
                    <div class="row grid_row">
                        <div class="col-6 col-sm-6 col-md-6 col-lg-6 col-xl-6">
                            <div class="label_txt">Email Address: </div>
                        </div>
                        <div class="col-6 col-sm-6 col-md-6 col-lg-6 col-xl-6 text-right">
                            <div class="label_txt">Phone Number: </div>
                        </div>
                        <div class="col-6 col-sm-6 col-md-6 col-lg-6 col-xl-6">
                            <div class="label_val">{{ email }}</div>
                        </div>
                        <div class="col-6 col-sm-6 col-md-6 col-lg-6 col-xl-6 text-right">
                            <div class="label_val">{{ phone_number }}&nbsp;&nbsp;</div>
                        </div>
                    </div>
                    <div class="row grid_row" v-if="isMenteeUserProfile()">
                      <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                          <div class="label_txt">Mentors: </div>
                      </div>
                      <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                          <div class="label_val">{{ group_names.join(', ') }}&nbsp;&nbsp;</div>
                      </div>
                    </div>
                    <div class="row grid_row" v-else>
                      <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                          <div class="label_txt">Groups: </div>
                      </div>
                      <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                          <div class="label_val">{{ group_names.join(', ') }}&nbsp;&nbsp;</div>
                      </div>
                    </div>
                </div>
            </div>
          </div>
          </div>
          </div>

          <div class="content-main-wrapper add_account_form center">
          <div class="db-card" v-show="isUser()">
            <div class="row justify-content-lg-center justify-content-xl-center">
              <div class="col-11">
                <div class="row">
                  <div class="col-6 col-sm-9 col-md-9 col-lg-10 col-xl-9">
                    <div class="title">Change Password</div>
                  </div>
                  <div class="col-6 col-sm-3 col-md-3 col-lg-2 col-xl-3 text-right">
                      <a @click="openUpdatePasswordForm()" class="btn btn-primary btn-sm dbEditBtn">Edit</a>
                  </div>
                </div>
                <hr class="view-mentee-hr"/> 
                <div class="row grid_row">
                  <div class="col-6 col-sm-9 col-md-9 col-lg-10 col-xl-9">
                    <div class="title">Password</div>
                  </div>
                  <div class="col-6 col-sm-3 col-md-3 col-lg-2 col-xl-3 text-right">
                    ********
                  </div>
                </div>
              </div>
            </div>
          </div>
          </div>
          

          <div class="content-main-wrapper add_account_form center" v-show="isMenteeProfile()">
          <div class="db-card">
            <div class="row justify-content-lg-center justify-content-xl-center">
                <div class="col-11">
                    <div class="row">
                        <div class="col-6 col-sm-9 col-md-9 col-lg-10 col-xl-9">
                            <span class="title">My Task Lists</span>
                        </div>
                    </div>
                    <hr class="view-mentee-hr"/> 
                    <div class="col-12 p-0" v-if="mappedTaskLists.length > 0">
                        <div class="db-report-card" v-for="(item, lindex) in mappedTaskLists" :key="lindex">
                            <div class="row">
                                <div class="col-9 col-sm-9 col-md-9 col-lg-8 col-xl-9 db_name_block">
                                    <div class="db-mentee-name">{{item.name}}</div>
                                    <div class="mt-2 question_text color-blue" style="padding-right: 16px; padding-top: 6px; text-decoration: underline;">
                                        <router-link :to="'/mentee-reps-goallist/' + userId + '/' + item.id">
                                            Task Goals
                                        </router-link>
                                    </div>
                                </div>
                                <div class="col-3 col-sm-3 col-md-3 col-lg-4 col-xl-3">
                                 <div style="text-align: right;">
                                    <router-link :to="'/mentee-reps-tasklist/'  + userId + '/' + item.id" class="btn btn-primary btn-md start-button-blue">
                                    Tasks
                                    </router-link>
                                 </div>  
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-12 mt-2 db-empty-card" v-else>
                        <div class="db-empty-card">
                            <h6 class="empty-content-title">No Assigned Task Lists</h6>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        </div>

          <div class="content-main-wrapper add_account_form center">
          <div class="db-card" v-show="isUser() && !entepriseAdmin && !researcher && !csr">
            <div class="row justify-content-lg-center justify-content-xl-center">
                <div class="col-11">
                    <div class="row">
                        <div class="col-6 col-sm-9 col-md-9 col-lg-10 col-xl-9">
                            <span class="title">Assessments</span>
                        </div>
                    </div>
                    <hr class="view-mentee-hr"/> 
                    <div class="col-12 p-0" v-if="assessments.length > 0">
                        <div class="" v-for="(assessment, aindex) in assessments" :key="aindex">
                          <div class="db-report-card" v-if="assessment.complete_attempt_id">
                            <div class="row">
                                <div class="col-9 col-sm-9 col-md-9 col-lg-8 col-xl-9 db_name_block">
                                    <div class="db-mentee-name">
                                      <strong>{{ assessment.title }}</strong>
                                      <div class="question_text">
                                      {{ assessment.question_count }} Questions
                                      </div>
                                    </div>

                                </div>
                                <div class="col-3 col-sm-2 col-md-4 col-lg-3 col-xl-3 p-0" style="padding-top: 3px !important;">
                                  <div class="col-12" style="text-align: right;">
                                  <button type="submit" class="btn btn-primary btn-md start-button-blue"  v-on:click="goToAssessmentLanding(assessment.id, assessment.inprogress_attempt_id, assessment.question_count)">{{ assessment.button_text }}</button> 
                                  </div>
                                </div>
                                <div class="col-12 question_text color-blue" style="text-align: right; padding-right: 16px; padding-top: 6px; "  v-if="assessment.complete_attempt_id"> 
                                <router-link :to="'assessment-report/' + assessment.complete_attempt_id" style="">
                                View Results
                                </router-link>
                                </div>
                                </div>
                        </div>
                        </div>
                    </div>
                    <div class="col-12 mt-2 db-empty-card" v-else>
                        <div class="db-empty-card">
                            <h6 class="empty-content-title">No Assessments Assigned</h6>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        </div>

            <div class="content-main-wrapper add_account_form center">    
            <div class="db-card" v-show="isUser() && !entepriseAdmin  && !researcher && !csr">
            <div class="row justify-content-lg-center justify-content-xl-center">
              <div class="col-11">
                <div class="row">
                  <div class="col-6 col-sm-9 col-md-9 col-lg-10 col-xl-9">
                    <div class="title">My Documents</div>
                  </div>
                  <div class="col-6 col-sm-3 col-md-3 col-lg-2 col-xl-3 text-right">
                      
                  </div>
                </div>
                <hr class="view-mentee-hr"/> 
                
                <div class="col-12 p-0" v-if="forms.length > 0">
                      <div class="db-report-card" v-for="(form, findex) in forms" :key="findex">
                        <div class="row" >
                          <div class="col-9 col-sm-10 col-md-8 col-lg-9 col-xl-9">
                            <strong>{{ form.name}}</strong>                           
                            <div class="mt-2 question_text color-blue" style="padding-right: 16px; padding-top: 6px;">
                                <router-link :to="'/update-fill-form/' + form.id + '/' + userId">
                                    Edit Form
                                </router-link>
                            </div>
                          </div>
                          <div class="col-3 col-sm-2 col-md-4 col-lg-3 col-xl-3 p-0" style="padding-top: 3px !important;">
                            <div class="col-12" style="text-align: right;">
                            <button type="submit" class="btn btn-primary btn-md start-button-blue" style="margin-top: 0px;" v-on:click="goToViewForm(form.id)">View Form</button> 
                            </div>
                            
                          </div>
                        </div>
                      </div>    
                    </div>

                     <div class="col-12 mt-2 db-empty-card" v-else>
                            <div class="db-empty-card">
                                <h6 class="empty-content-title">No Documents</h6>
                            </div>
                        </div>

              </div>

            </div>
          </div>
          </div>


          <div class="content-main-wrapper add_account_form center">
          <div class="db-card" v-show="isUser() && !entepriseAdmin && !researcher && !csr">
            <div class="row justify-content-lg-center justify-content-xl-center">
                <div class="col-11">
                    <div class="row">
                        <div class="col-6 col-sm-9 col-md-9 col-lg-10 col-xl-9">
                            <span class="title">My Preferences</span>
                        </div>
                    </div>
                    <hr class="view-mentee-hr"/> 
                    <div class="col-12 p-0" >
                        <div class="" >
                          <div class="db-report-card" >
                            <div class="row">
                                <div class="col-11 db_name_block">
                                    <div class="db-mentee-name">
                                      Communication
                                    </div>
                                  <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 cols" style="padding-left: 40px; padding-bottom: 5px;">
                                    <input
                                      type="checkbox"
                                      v-bind:id="news_subscription"
                                      v-bind:name="news_subscription"
                                      ref="news_subscription"
                                      v-model="news_subscription_selected"
                                      :checked="news_subscription_checked" @click="changeUserNewsSubscribe($event)"
                                      :value="1" style="margin-top: 4px; height: 12px;"
                                      >
                                    <label class="preference-heading" for="submit_comment_1">News, updates, promotions & more!</label>
                                  </div>

                                    <div class="db-mentee-name">
                                      Frequency
                                    </div>

                                  <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 cols" style="padding-left: 20px; padding-bottom: 0px;">
                                    <div class="custom-control " >
                                        <div class="col-5 p-0 float-left">
                                        <label for="notification"  style="padding-top:2px;" class="preference-heading">Mentoring support communication</label>
                                        </div>
                                        <div class="search-padd float-left col-4">
                                            <select 
                                            class="custom-select" 
                                            id="frequency" 
                                            name="frequency" 
                                             v-model="frequency" @change="changeUserFrequency()"
                                            >
                                            <option v-for="(item, index) in frequency_options" :key="index" :value="item.value">{{ item.text }}</option>
                                            </select>
                                        </div>
                                        <div style="clear: both;"></div>
                                    </div>
                                  </div>
                                  <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 cols" style="padding-left: 45px; padding-bottom: 5px;">
                                    <label for="notification"  style="padding-top:0px; font-size: 11px; font-style: italic; color: #B1B8BA;" class="preference-heading">A successful mentoring program is based on consistent communication Mentor Mentee recommends your communication frequency remain on default.</label>
                                  </div>


                                </div>
                                </div>
                        </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        </div>


        </div>
      </div>  
    </div>
  </div>  
  <EditProfile
    :isModalVisible="isEditProfileModalVisible"
    ref="edit_profile_form"
    @close="isEditProfileModalVisible = false">
  </EditProfile>
  <UpdatePassword
    :isModalVisible="isUpdatePasswordModalVisible"
    ref="update_password_form"
    @close="isUpdatePasswordModalVisible = false">
  </UpdatePassword>

      <PreferenceUpdateConfirmModal :isModalVisible="isPrefereceUpdateConfirmModalVisible"  @close="closeConfirm()">
        <span v-if="loading" class="pull-right text-danger">
          Loading...
        </span>
        <div slot="header" class="sub-heading" style="margin-left: 0;">{{ modal_title }}</div>
        <div slot="body">
          <span v-html="modal_message"></span>
        </div>
        <div slot="footer" class="col-12 p-0">
          <div class="col-6 float-left p-0">
            <button class="btn btn-sm ma-white-btn1" @click="closeConfirm()">Cancel</button>
          </div>
          <div class="col-6 float-left p-0 text-align-right">
            <button v-if="buttonTitle == 'Update'" class="btn btn-sm ma-blue-btn1" @click="onFrequencySubmit()">{{ buttonTitle }}</button>
            <button v-else class="btn btn-sm ma-blue-btn1" @click="onSubscribeNewsSubmit()">{{ buttonTitle }}</button>
          </div>
          <div style="clear: both;"></div>
        </div>
      </PreferenceUpdateConfirmModal>



      <SuccessConfirmModal :isModalVisible="isSuccessConfirmModalVisible"  @close="closeSuccessConfirm()">
        <span v-if="loading" class="pull-right text-danger">
          Loading...
        </span>
        <div slot="header" class="sub-heading" style="margin-left: 0;">{{ modal_success_title }}</div>
        <div slot="body">
          <span v-html="modal_success_message"></span>
        </div>
        <div slot="footer" class="col-12 p-0">
          <div class="col-12 text-center">
            <button class="btn btn-sm ma-blue-btn1" @click="closeSuccessConfirm()">Close</button>
          </div>
          <div style="clear: both;"></div>
        </div>
      </SuccessConfirmModal>





</div>
</template>

<script>
import Vue from 'vue/dist/vue.esm';
import GoBack from './shared/goback.vue';
import VeeValidate from 'vee-validate';
import axios from 'axios';
import router from '../router/index.js';
import { store } from '../store/store';
import UserMenu from './shared/user_menu.vue';
import MasteradminSidebarMenu from './shared/masteradmin_sidebar_menu.vue';
import {ValidationMethods} from './shared/common_validations.js';
import AdminSidebarMenu from './shared/admin_sidebar_menu.vue';
import EditProfile from './edit_profile.vue';
import UpdatePassword from './update_password.vue';
import PreferenceUpdateConfirmModal from './admin/preference_confirm_modal.vue';
import SuccessConfirmModal from './admin/preference_confirm_modal.vue';


Vue.use(VeeValidate, { errorBagName: 'verrors', fieldsBagName: 'vfields'});

export default {
  mixins: [ValidationMethods],
  data() {
   return {
      action: 'view-profile',
      first_name: '',
      last_name: '',
      phone_number: '',
      email: '',
      roles: [],
      role_options: [],
      groups: [],
      group_names: [],
      groups_options: [],
      update_url: '',
      get_url: '',
      password: '',
      confirm_password: '',
      admin_flag: false,
      email_flag: false,
      sms_flag: false,
      loading: false,
      taskListsAssigned: [],
      taskListsNames: [],
      editTaskLists: [],
      showGroupEdit: false,
      notification_phone: false,
      email_display_flag: 'No',
      sms_display_flag: 'No',
      frequency_options: [
        { value: 'DAILY', text: 'Daily' },
        { value: 'WEEKLY', text: 'Weekly' },
      ],
      frequency_value: 'DAILY',
      masterAdmin: false,
      admin: false,
      pageName: 'MY PROFILE',
      is_mentee: 0,
      showBackButton: false,
      isEditProfileModalVisible: false,
      isUpdatePasswordModalVisible: false,
      mappedTaskLists: [],
      userId: '',
      forms: [],
      assessments: [], 
      entepriseAdmin: false,
      researcher: false,
      csr: false,
        news_subscription: 'news_subscription',
        news_subscription_selected: false,
        news_subscription_checked: 0,
        frequency: 'Daily',
        frequency_options: [
            {value: '', text: 'Select Frequency'},
            {value: 'Daily', text: 'Daily (Default)'},
            {value: 'Tuesdays', text: 'Tuesdays'},
            {value: 'Wednesdays', text: 'Wednesdays'},
            {value: 'Thursdays', text: 'Thursdays'},
        ],
        isPrefereceUpdateConfirmModalVisible: false,
        isSuccessConfirmModalVisible: false,
          buttonTitle: '',
          modal_title: '',
          modal_message: '',
          modal_success_title: '',
          modal_success_message: '',
          oldNewsSubscribe: '',
          oldFrequency: '',
    }
  },
  components: {
    GoBack,
    UserMenu,
    MasteradminSidebarMenu,
    AdminSidebarMenu,
    EditProfile,
    UpdatePassword,
    PreferenceUpdateConfirmModal,
    SuccessConfirmModal,
  },
  methods: {
        changeUserFrequency() {
            if(this.frequency != '') {
                this.buttonTitle = 'Update';
                this.modal_title = 'Are you sure you want to change the frequency of your Mentor Mentee support Communication?';
                this.modal_message = 'A successful mentoring program is based on consistent communication. <i>Mentor Mentee recommends your communication frequency remain on default.</i>';
                this.isPrefereceUpdateConfirmModalVisible = true;
            }
        },
        changeUserNewsSubscribe(event) {
          this.oldNewsSubscribe = this.news_subscription_checked;
          if(event.target.checked == true) {
            this.buttonTitle = 'Subscribe';
            this.modal_title = 'Are you sure you want to subscribe to news, updates, promotions & more!?';
            this.modal_message = '';
          }
          else {
            this.buttonTitle = 'Unsubscribe';
            this.modal_title = 'Are you sure you want to unsubscribe from news, updates, promotions & more!?';
            this.modal_message = 'You will still receive transactional & account-related support emails.';
          }
          this.isPrefereceUpdateConfirmModalVisible = true;
        },
        closeSuccessConfirm() {
          this.isSuccessConfirmModalVisible = false;
          this.preference_news_subscription_selected = '';
          this.$emit('close');
          this.navigate();
        },
        closeConfirm() {
          if((this.oldNewsSubscribe == 0) || (this.oldNewsSubscribe == 1)) {
            this.news_subscription_checked = this.oldNewsSubscribe;
            if(this.news_subscription_checked == 0) {
                this.news_subscription_selected = false;
            }
            else {
                this.news_subscription_selected = true;
            }
          }
          if(this.oldFrequency) {
            this.frequency = this.oldFrequency;  
          }
          this.isPrefereceUpdateConfirmModalVisible = false;
          this.$emit('close');
        },
        onFrequencySubmit() {
          axios('/account_lookup/frequency_update',
              {
              method: 'POST',
              data: {
                  frequencyType: this.frequency,
                  account_id: this.$store.state.user_accountid,
                  user_id: this.userId,
              }
              },
          )
          .then(response => {
              this.modal_success_title = 'Mentoring Support Communication Updated';
              this.modal_success_message = 'Your communication preferences have been updated to ' + this.frequency + '.';
              this.isPrefereceUpdateConfirmModalVisible = false;
              this.isSuccessConfirmModalVisible = true;
          })
          .catch(error => {

          })
        },
        onSubscribeNewsSubmit() {
          axios('/account_lookup/news_subscription_update',
              {
              method: 'POST',
              data: {
                  isSubscribeNews: this.news_subscription_selected,
                  account_id: this.$store.state.user_accountid,
                  user_id: this.userId,
              }
              },
          )
          .then(response => {
            if((this.news_subscription_selected == true)) {
              this.modal_success_title = 'Mentoring Support Communication Updated';
              this.modal_success_message = 'Subscribed to mentoring news, updates, promotions & more!';
              this.isPrefereceUpdateConfirmModalVisible = false;
              this.isSuccessConfirmModalVisible = true;
            }
            else if((this.news_subscription_selected == false)) {
              this.modal_success_title = 'Mentoring Support Communication Updated';
              this.modal_success_message = 'Unsubscribed to mentoring news, updates, promotions & more!';
              this.isPrefereceUpdateConfirmModalVisible = false;
              this.isSuccessConfirmModalVisible = true;
            }

          })
          .catch(error => {

          })
        },          


      goToAssessmentLanding: function(assessmentId, assessmentAttemptId, questionCount) {
        if(assessmentAttemptId) {
          router.push('/assessment-landing-page/' + assessmentId + '/' + assessmentAttemptId);
        }
        else {
          axios('/desktop/user-assessment-attempts/' + assessmentId + '/' + this.$store.state.user_accountid,
          {
            method: 'POST',
          })
          .then((resp) => {
            router.push('/assessment-landing-page/' + assessmentId + '/' + resp.data);
          })
          .catch(() => {

          });
        }
      },
    openEditProfileForm() {
      this.isEditProfileModalVisible = true;
      this.$refs.edit_profile_form.getProfileUser();
    },
    openUpdatePasswordForm() {
      this.isUpdatePasswordModalVisible = true;
    },
    isUser() {
      if(this.$route.params.user_id) {
          return false;
      }
      else {
          return true;
      }
    },
    isMenteeProfile() {
      if((this.roles.indexOf('ROLE_MENTEE') !='-1') || (this.roles.indexOf('ROLE_APPRENTICE') !='-1') || (this.roles.indexOf('ROLE_STUDENT') !='-1')) {
          return true;
      }
      else {
          return false;
      }
    },
    isMenteeTasklistEdit() {
      var loggedinUserRoles = store.state.roles;
      if(((loggedinUserRoles.indexOf('ROLE_ADMIN') != '-1') || (store.state.switch_admin_username)) && (this.roles.indexOf('ROLE_MENTEE') !='-1')) {
          return true;
      }
      else {
          return false;
      }
    },
    isMenteeNotificationSettings() {
      var loggedinUserRoles = store.state.roles;
      if((loggedinUserRoles.indexOf('ROLE_MENTEE') != '-1') || (loggedinUserRoles.indexOf('ROLE_STUDENT') !='-1')) {
          if(this.userGroupRole == 'ROLE_MENTEE') {
            return true;
          }
          else {
            return false;
          }
      }
      else {
          return false;
      }
    },
    isMenteeUserProfile() {
      var userRoles = this.roles;
      if((userRoles.indexOf('ROLE_MENTEE') != '-1') || (userRoles.indexOf('ROLE_STUDENT') !='-1')) {
          if(this.userGroupRole == 'ROLE_MENTEE') {
            return true;
          }
          else {
            return false;
          }
      }
      else {
          return false;
      }
    },
    displayNotificationSetting: function() {
      if(this.sms_flag === true) {
        this.notification_phone = true;
      }
      else {
        this.notification_phone = false;
      }
    },
    updateMenteesNotifications () {
      this.$validator.validateAll().then((result) => {
        if(!result){
          return;
        }
        axios('/mentees-notification-update',
          {
            method: 'POST',
            data: {
                "email_flag": this.email_flag,
                "sms_flag": this.sms_flag,
                "phone_no": this.phone_number,
                "frequency": this.frequency_value,
                },
          }
        )
       .then((resp) => {
          this.flash({ message: resp.data, variant: 'success' });
          this.navigate("/myprofile");
        })
       .catch(error => {

       });
      }).catch(() => {
        // catches the error;
      });
    },

    onSubmit () {
      this.$validator.validateAll().then((result) => {
        if(!result){
          return;
        }
        this.pwd_update();
      }).catch(() => {
        // catches the error;
      });
    },
    onUpdate () {
      this.$validator.validateAll().then((result) => {
        if(!result){
          return;
        }
        this.update();
      }).catch(() => {
        // catches the error;
      });
    },
    pwd_update: function() {
      axios('/password-update',
        {
          method: 'PATCH',
          data: {password: this.password},
        }
      )
     .then((resp) => {
       this.$store.dispatch('logout');
       this.flash({ message: 'Your password is changed. Please login.', variant: 'success' });
       this.navigate("/login");
      })
     .catch(error => {

     });
    },
    update: function () {
      if(this.$route.params.user_id) {
        this.update_url = '/user-profile/' + this.$route.params.user_id;
      }
      else {
        this.update_url = '/my-profile';
      }
      var userAccountId = '';
      if(store.state.user_accountid) {
        userAccountId = store.state.user_accountid;
      }
       axios(this.update_url,
         {
           method: 'PATCH',
           data:  {
                    first_name: this.first_name,
                    last_name: this.last_name,
                    phone_number: this.phone_number,
                    roles: this.roles,
                    userGroups: this.groups,
                    accountId: userAccountId,
                  },
         }
       )
      .then((resp) => {
        this.flash({ message: 'Your profile is updated.', variant: 'success' });
        this.navigate("/profile/" + this.$route.params.user_id);
       })
      .catch(error => {
          const fieldErrors =  [{}];
            var errMsgObj = error.response.data.message;

            Object.keys(errMsgObj).map(key => {
               var newFieldErr = {field:key, msg:errMsgObj[key]};
               fieldErrors.push(newFieldErr);
            });
            this.$validator.errors.add(fieldErrors);
      });
    },
    setprofile_mode(viewmode) {
      this.action = viewmode
    },
    goBack() {
      this.$router.go(-1)
    },
    navigate(pathUrl) {
      router.go({
        path: pathUrl,
        force: true
      });
    },
    isInArray(value, array) {
      return array.indexOf(value) > -1;
    },
    updateMenteesTasklist () {
      this.$validator.validateAll().then((result) => {
        if(!result){
          return;
        }
        axios('/mentees-tasklist-update/' + this.$route.params.user_id,
          {
            method: 'POST',
            data: {"tasklists_assigned": this.taskListsAssigned},
          }
        )
       .then((resp) => {
          this.flash({ message: resp.data.successMsg, variant: 'success' });
          this.navigate("/profile/" + this.$route.params.user_id);
        })
       .catch(error => {

       });
      }).catch(() => {
        // catches the error;
      });
    },
    checkUserMultipleGroupPermission() {
      var loggedinUserRoles = store.state.roles;
      if((this.roles.indexOf('ROLE_MENTEE') !='-1' ||
        this.roles.indexOf('ROLE_INSTRUCTOR') !='-1' ||
        this.roles.indexOf('ROLE_STUDENT') !='-1' ) &&
        ((loggedinUserRoles.indexOf('ROLE_MENTEE') === -1) &&
        (loggedinUserRoles.indexOf('ROLE_STUDENT') === -1))) {
          return true;
      }
      else {
          return false;
      }
    },
    rolesFormatter(value) {
        let formattedRoles = value.replace(new RegExp('ROLE_', 'g'),'');
        formattedRoles =  formattedRoles.replace(new RegExp('_', 'g'),' ');
        return formattedRoles.toLowerCase();
    },
    goToViewForm(formId) {
      if (this.$store.state.user_accountid) {
        var formViewUrl = '/desktop/forms-manager/view-form/'+formId+'/' + this.$store.state.user_accountid;
      } else {
        if (store.state.roles.indexOf('ROLE_MASTER_ADMIN') > -1) {
          formViewUrl = '/forms-manager/view-form/'+formId;
        }
      }
      
     axios.get(formViewUrl, {
      })
      .then(response =>  {        
        window.open(process.env.API_ENDPOINT + '/web/forms/' +response.data.filepath, '_blank');                        
      })
      .catch(function(err) {
        console.log("Come here"+ err);
      });
    },
  },
  created: function() {
    var roles = this.$store.state.roles;
    if(roles.indexOf('ROLE_MASTER_ADMIN') > -1) {
      this.masterAdmin = true;
    }
    if(roles.indexOf('ROLE_RESEARCHER') > -1) {
      this.researcher = true;
    }
    if(roles.indexOf('ROLE_CSR') > -1) {
      this.csr = true;
    }
    if(roles.indexOf('ROLE_ENTERPRISE_ADMIN') > -1) {
      this.entepriseAdmin = true;
    }
    if(
      ((roles.indexOf('ROLE_ADMIN') > -1)
      ||
      (this.$store.state.switch_admin_username))
      &&
      ((this.$store.state.switch_flag != 'Instructor')
      &&
      (this.$store.state.switch_flag != 'Mentor'))
      ) {
      this.admin = true;
    }

    if(
      ((roles.indexOf('ROLE_MENTOR') > -1)
      ||
      (roles.indexOf('ROLE_MENTEE') > -1)
      ||
      (roles.indexOf('ROLE_INSTRUCTOR') > -1)
      ||
      (roles.indexOf('ROLE_STUDENT') > -1))
      &&
      ((this.$store.state.switch_flag != 'Manager')
      &&
      (this.$store.state.switch_flag != 'Primary Admin'))
      ) {
      this.showBackButton = true;
    }
    this.loading = true;
    document.body.className = 'profile-page';
    if(this.$route.params.user_id) {
      this.get_url = '/user-profile/' + this.$route.params.user_id;
      this.pageName = 'User Profile';
    }
    else {
      this.get_url = '/my-profile';
      this.pageName = 'My Profile';
    }
    var userAccountId = '';
    if(store.state.user_accountid) {
      userAccountId = store.state.user_accountid;
    }
    axios(this.get_url,
      {
        method: 'POST',
        data: {
               "accountId": userAccountId,
        }
      }
    )
    .then(resp => {
      this.loading = false;
      for(var i=0; i < resp.data.user.groups.length; i++) {
        this.groups.push(resp.data.user.groups[i].id);
        this.group_names.push(resp.data.user.groups[i].name);
      }
      this.userId = resp.data.user.userId;
      this.first_name = resp.data.user.first_name;
      this.last_name = resp.data.user.last_name;
      this.phone_number = resp.data.user.phone_number;
      this.email = resp.data.user.email;
      this.roles = resp.data.user.roles;
      this.role_options = resp.data.roleoptions;
      this.groups_options = resp.data.groupsoptions;
      this.admin_flag = resp.data.adminflag;
      this.is_mentee = resp.data.user.is_mentee;

      this.news_subscription_selected = resp.data.isSubscribeNews;
      if(this.news_subscription_selected == true) {
        this.news_subscription_checked = 1;
      }
      this.frequency = resp.data.frequencyType;
      this.oldFrequency = resp.data.frequencyType;
      if((!this.frequency) && (resp.data.isDisableNotify) == false) {
        this.frequency = 'Daily';
        this.oldFrequency = 'Daily';
      }

      if(this.isMenteeProfile())
      {
          this.mappedTaskLists = resp.data.user.taskLists;
          for(var j=0; j < resp.data.user.taskLists.length; j++) {
            this.taskListsAssigned.push(resp.data.user.taskLists[j].id);
            this.taskListsNames.push(resp.data.user.taskLists[j].name);
          }
          this.userGroupRole = resp.data.user.userGroupRole;
          this.email_flag = resp.data.user.emailFlag;
          if(this.email_flag === true) {
            this.email_display_flag = 'Yes';
          }
          else {
            this.email_display_flag = 'No';
          }
          this.sms_flag = resp.data.user.smsFlag;
          if(this.sms_flag === true) {
            this.notification_phone = true;
            this.sms_display_flag = 'Yes';
          }
          else {
            this.sms_display_flag = 'No';
          }
          this.frequency_value = resp.data.user.frequency;
      }
      this.showGroupEdit = this.checkUserMultipleGroupPermission();
    })
    .catch(error => {
      this.loading = false;
    })
    if(!this.entepriseAdmin && !this.researcher && !this.csr) 
    {
      if ((userAccountId)) {
        var formSubmittedUrl = '/desktop/user/submitted-form-lists/' + userAccountId;  
      } else {
        if (store.state.roles.indexOf('ROLE_MASTER_ADMIN') > -1) {
          formSubmittedUrl = '/user/submitted-form-lists';
        }
      }
      axios.get(formSubmittedUrl, {
      })
      .then(response =>  {
        this.forms = response.data;
      })
      .catch(function() {
        
      });
      if((!this.researcher) && (!this.csr)) {
      axios.get('/desktop/user/assessment-lists/' + this.$store.state.user_accountid, {
      })
      .then(response =>  {
        this.assessments = response.data.assessment;
      })
      .catch(function() {
        console.log("Come here");
      });
      }
    }
  },
  mounted() {
    var loggedinUserRoles = store.state.roles;
    if(loggedinUserRoles.indexOf('ROLE_ADMIN') !='-1'
        || (loggedinUserRoles.indexOf('ROLE_ADMIN') !='-1'
            && loggedinUserRoles.indexOf('ROLE_MENTOR') !='-1') || (store.state.switch_admin_username)) {
      axios('/alltasklists-account',
        {
          method: 'GET',
          params: { 
            "account_id": store.state.user_accountid,
          }
        },
      )
      .then(response => {
            this.editTaskLists = response.data;

       })
      .catch(error => {

      });
    }
  },
}
</script>

<style scoped>

.db-card {
  background-color: #FFF;
  width: 100%;
  min-height: 120px;
  padding: 10px;
  margin: 10px 0;
  border-radius: 10px;  
}
.db-card .db-mentee-name {
  font-weight: 600;
  word-break: break-word;
}
.db-card .db-mentor-name {
  word-break: break-word;
  font-weight: 900;
}
.db-card .db-mentor-name span{
  word-break: break-word;
  font-weight: normal;
}
.grid_row {
  margin-top: 10px;
}
/* .grid_row .cols { padding: 0; } */
.db-card .label_txt {
  font-weight: 900;
  margin-bottom: 5px;
}
.saveBtn, .saveBtn:active, .saveBtn:focus {
  color: #FFF; 
  background-color: #00acee !important;
  border: 1px solid #00acee !important;
  border-radius: 10px;
  font-weight: 900;
  width: 120px;  
}
.container {
    max-width: 990px;
}
.dbViewBtn{
  color: #00acee !important;
  background-color: #FFF;
  border: 1px solid #00acee !important;
  border-radius: 10px;
  font-size: 13px;
  font-weight: 900;
  padding: 5px;
  line-height: 8px;
  width: 50px;
  float: right;
}
.dbViewBtn:focus, .dbViewBtn:active {
  color: #00acee !important;
  background-color: #FFF !important;
  border: 1px solid #00acee !important;
} 
.user-icon{ font-size: 60px;  margin-bottom: 10px; }
.mentor_row { margin: 30px; }
.db-card .title{
  font-size: 15px;
  font-weight: 900;
}
.db-card .db-report-card {
  background-color: #e8e8e8;
  border-radius: 5px;
  min-height: 40px;
  padding: 10px;
  margin: 10px 0;
}
.db-card .db-empty-card {
  background-color: #e8e8e8;
  border-radius: 5px;
  min-height: 40px;
  padding: 10px;
  text-align: center;
}
a.dbEditBtn {
  color: #00ACEE !important;
  border: 0px solid #29A3E4;
  background: none;
  font-size: 13px;
  font-weight: 900;
  padding: 5px;
  line-height: 8px;
  text-decoration: underline !important;
  text-align: right;
}
a.dbEditBtn {
  width: 50px;
  float: right;
  margin-top: 15px;
}
.dbEditBtn:focus, .dbEditBtn:hover {
  color: #00acee !important;
  background:none !important;
  border: 0px solid #00acee !important;
  box-shadow: none !important;
} 

.dbGoalBtn {
  text-decoration: underline;
  color: #7d7d7d !important;
}
.db-card .empty-content-title{
  font-size: 13px;
  font-weight: 600;
  text-align: center;
}
.view-mentee-hr {
    margin-top: 5px;
    margin-bottom: 0px;
    border: 1px solid #00ACEE;
}
/* Small Devices */
@media (min-width: 320px) and (max-width: 991px) { 
    .statusBtn, .statusBtn:active, .statusBtn:focus {
        width: 100%;
    }
}



.dialogbox .body {
  position: relative;
  max-width: 300px;
  height: auto;
  margin: 20px 10px;
  padding: 5px;
  border-radius: 3px;
  border: 5px solid #ccc;
}

.body .message {
  min-height: 30px;
  border-radius: 3px;
  font-family: Arial;
  font-size: 14px;
  line-height: 1.5;
  color: #797979;
}
    .slide-leave-active,
    .slide-enter-active {
      transition: 0.4s;
    }
    .slide-enter {
      transform: translate(100%, 0);
    }
    .slide-leave-to {
      transform: translate(-100%, 0);
    }
.profile-page .main-wrapper {
   background-color: #FFF;
   padding: 10px;
   min-height: 400px;
   transform: none;
   margin-top:20px;
   width: 50%;
}
@media(max-width:768px) {
  .profile-page .main-wrapper {
     width: 70%;
   }
}
@media (max-width: 560px) {
 .profile-page .main-wrapper {
    border-radius: 5px;
    width: 100%;
  }
}
@media (max-width: 575.98px) {
  .col-xs-1 {
   width: 8.33333333%;
  }
  .col-xs-11 {
    width: 91.66666667%;
  }
  .col-xs-4 {
    width: 33.333333%;
  }
  .col-xs-8 {
    width: 66.666667%;
  }
  .col-xs-9 {
    width: 75%;
  }
  .col-xs-3 {
    width: 25%;
  }
}
.content-main-wrapper h3 {
  text-transform: uppercase;
  font-weight: 700;
  font-size: 14px;
  color: #555;
}
.marginbot10 {
  margin-bottom: 10px;
}
.profile-heading {
  margin-top: 10px;
}
label {
  font-size: 12px;
}
.profile-sec-sep {
  border-top: 1px solid #DDD;
  margin: 20px 0px 20px 0px;
}
#profile-link-wrapper .profile-link {
  color: #007bff;
  text-decoration: none;
  cursor: pointer;
}
#edit-profile-wrapper label {
  padding-left: 0px;
}
.edit-profile-wrapper .submit{
  padding-right: 15px;
  margin-top: 10px;
}
.custom-chkbox {
  width: 10%;
  float: left;
}
label.group-chkbox {
  font-weight: normal;
}
.roles { text-transform: capitalize; }
.profile-container label{
  font-weight:bold;
}
.profile-container .chkboxwrapper label{
  font-weight:normal;
}

.edit-profile-wrapper {
  padding-top: 10px;
}
.question_text, .question_text a, .question_text a:hover {
  font-size: 11px;
  color: #002F42;
}
.color-blue a, .color-blue a:hover{
  color: #29A3E4 !important;
  text-decoration: underline;
  font-weight: bold;
}
.start-button {
    color: #29A3E4;
    background-color: #FFF !important;
    border: 1px solid #29A3E4 !important;
    border-radius: 10px;
    font-size: 13px;
    font-weight: 900;
    padding: 10px 10px 10px 10px;
    line-height: 8px;
    width: 110px;
}
.start-button-blue {
    color: #fff;
    background-color: #29A3E4 !important;
    border: 1px solid #29A3E4 !important;
    border-radius: 10px;
    font-size: 13px;
    font-weight: 900;
    padding: 10px 10px 10px 10px;
    line-height: 8px;
    width: 87px; 
}
.content-main-wrapper {
  width: 75%;
  background-color: #FFF;
  padding: 30px;
  margin-bottom: 20px;
}
.personal-details-wrapper {
  padding-left: 15%;
  padding-right: 15%;   
}
.custom-select {
    height: 25px;
    padding: 0;
    padding-left: 10px;
}
.preference-heading {
    font-size: 14px;
}
.ma-blue-btn1 {
  color: #FFF !important; 
  background-color: #00acee !important;
  border: 1px solid #00acee !important;
  font-weight: 900;
  border-radius: 10px;
  width: 120px;
}
.ma-white-btn1 {
  color: #00ACEE !important; 
  background-color: #FFF !important;
  border: 1px solid #00ACEE !important;
  font-weight: 900;
  border-radius: 10px;
  width: 90px;
}
</style>



// WEBPACK FOOTER //
// src/components/my_profile.vue